<template>
  <div class="container onboard-container">
    <div class="columns">
      <div class="column is-two-thirds equal-height">
        <div class="form-box">
          <form @submit="handleCreateAccount" name="createfree" v-show="signUp.step === 1 || signUp.step === 2">
            <h1 class="create-your-account second-step">Let’s Look Up Your Business</h1>
            <p class="form-para has-text-centered">Your business may already be on Hellopeter. If it isn’t, you may add it.</p>
            <div class="container margin-top-20 biz-form">
              <div class="columns is-block">
                <div class="column padding-bottom-0 labels">Business Name</div>
                <div class="column padding-top-0 dropdown-section">
                  <div @mouseleave.self="hideBusinessAutoComplete" :class="['control business-name', { 'is-loading' : isFetchingBusinesses }, { 'has-icons-right' : isBusinessSelected }]">
                    <span class="selected-business" v-if="signUp.business_name && business_is_selected">{{signUp.business_name}}</span>
                    <input class="input" type="text" placeholder="Your Business Name" autocomplete="off" v-model="signUp.business_name" @keyup="handleSearchBusinesses" />
                    <div class="no-height" v-show="searchBusinessesFound && !business_is_selected">
                      <div class="dropdown is-active">
                        <div class="dropdown-menu" role="menu">
                          <div class="dropdown-content is-paddingless">
                            <div> <!-- v-if="!searchResults.length && signUp.business_name && !business_is_selected" -->
                              <div class="columns no-business-section">
                                <div class="column padding-0 no-business">
                                  My business isn’t here:
                                  <br><b>{{signUp.business_name}}</b>
                                </div>
                                <div class="column padding-0 has-text-right">
                                  <button class="button is-button-dark-blue is-uppercase" @click="handleAddBusiness">Add Now</button>
                                </div>
                              </div>
                              <p class="mini-notes"><b>Is one of these your business? If yes, please select from the list. If no, click the ADD NOW button.</b></p>
                            </div>
                            <a v-for="(business, key) in searchResults" @click.prevent="selectBusiness(business)" href="#" :ref="`${business.id}`" :key="`${key}`" class="dropdown-item has-text-left" v-text="business.name" v-if="searchResults"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns is-block">
                <div class="column padding-bottom-0 labels first-name-label place-in-center-mobile">First Name</div>
                <div class="column padding-top-0">
                  <input class="input" type="text" placeholder="Your First Name" v-model="signUp.first_name" />
                </div>
              </div>
              <div class="columns is-block">
                <div class="column padding-bottom-0 labels">Work Email</div>
                <div class="column padding-top-0">
                  <input class="input" type="text" placeholder="Your Work Email" v-model="signUp.email" />
                </div>
              </div>
              <div class="columns is-block">
                <div class="column padding-bottom-0 labels">Password</div>
                <div class="column padding-top-0 margin-bottom-4">
                  <vue-password placeholder="Password" classes="input force-height" :disableStrength="true" v-model="signUp.password"></vue-password>
                </div>
              </div>
              <div class="field policy-section">
                <div class="control">
                  <label class="label agree-label checkbox has-text-centered-desktop has-text-left-touch place-in-center-mobile">
                    <input type="checkbox" name="agreement" class="checkbox" v-model="signUp.agreed" /> &nbsp;
                    I agree to Hellopeter's <a href="https://www.hellopeter.com/legal/legal" target="_blank" class="hyperlinks">terms of service</a> and <a href="https://www.hellopeter.com/legal/privacy" target="_blank" class="hyperlinks">privacy policy</a>
                  </label>
                </div>
              </div>
<!--              <form name="createfree">-->
                <input type="submit" value="CREATE ACCOUNT" :class="['button is-uppercase create-account', { 'is-loading' : signUp.isLoading }]" :disabled="!isDetailCompleted || !validateEmail" />
<!--              </form>-->
              <!-- <p class=""> -->
                <!-- <button :class="['button is-uppercase create-account', { 'is-loading' : signUp.isLoading }]" :disabled="!isDetailCompleted" @click="handleCreateAccount">Create Account</button> -->
              <!-- </p> -->
            </div>
          </form>
          <div class="hero thank-you-hero" v-show="signUp.step === 3">
            <div class="hero-body">
              <div class="has-text-centered">
                <img src="/static/img/packages/like_icon.svg" width="60"/>
                <h1 class="thank-you-header is-size-1-widescreen is-size-2-tablet is-size-2-desktop is-size-4-mobile has-text-weight-bold height-100">
                  Your business profile<br/>is in our hands.
                  <p class="thank-you-msg ask-sign-in" v-html="showThankYouMessage"></p>
                </h1>
              </div>
            </div>
          </div>
          <p class="has-text-centered margin-top-10 ask-sign-in" v-show="signUp.step !== 3">Already have an account?<br/><router-link to="/login">Sign in now</router-link></p>
        </div>
      </div>
      <summary-section :cycle="frequency" :name="tier"></summary-section>
      <!-- ReCaptcha Begins -->
      <div class="columns" v-if="signUp.step !== 3">
        <div class="column is-marginless">
          <div class="has-text-right-tablet">
            <vue-recaptcha
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              size="invisible"
              :sitekey="`${google_recaptcha_site_key}`">
            </vue-recaptcha>
          </div>
        </div>
      </div>
      <!-- ReCaptcha Ends -->
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape,camelcase, valid-jsdoc */
  import axios from 'axios'
  import VuePassword from 'vue-password'
  import VueRecaptcha from 'vue-recaptcha'
  import SummarySection from '@/components/Summary'
  import misc from '@/mixins/misc'

  export default {
    name: 'FreeOnboard',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Free Onboard'
    },
    components: {
      VuePassword,
      VueRecaptcha,
      SummarySection
    },
    mixins: [misc],
    props: {
      tier: {
        type: String,
        default: 'free'
      },
      frequency: {
        type: String,
        default: 'monthly'
      }
    },
    data () {
      return {
        formsApiAxios: undefined,
        signUp: {
          step: 1,
          email: '',
          token: '',
          agreed: '',
          password: '',
          isLoading: false,
          first_name: '',
          business_id: 0,
          business_name: '',
          businessSlug: '',
          free_reference: '',
          tracking_reference: null,
          hubspot_cookie: null
        },
        isAddingBiz: false,
        searchResults: [],
        businessAxios: undefined,
        is_fetching_business: false,
        business_is_selected: false,
        selected_business_available: false,
        google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY
      }
    },
    computed: {
      /**
       * Check if all the fields filled in form
       * @return {boolean}
       */
      isDetailCompleted () {
        return this.signUp.email.length > 0 && this.signUp.password.length > 0 && this.signUp.first_name.length > 0 && this.signUp.business_name.length > 0 && this.signUp.agreed
      },
      /**
       * Check if business found
       * @return {boolean}
       */
      searchBusinessesFound () {
        return (this.searchResults.length > 0 || this.signUp.business_name)
      },
      /**
       * Check if business is selected
       * @return {boolean}
       */
      isBusinessSelected () {
        return this.business_is_selected
      },
      isFetchingBusinesses () {
        return this.is_fetching_business
      },
      /**
       * Check if email is valid
       * @return {boolean}
       */
      validateEmail () {
        const test = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return test.test(String(this.signUp.email).toLowerCase())
      },
      /**
       * Prepare thank you message
       * @return {string}
       */
      showThankYouMessage () {
        // change message based on whether or not the package is free
        const bold = `<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>`
        const remainder = `Our team will review your information. Once this is done, your account<br/>will be activated and a welcome email will be sent to ${this.signUp.email} to get you started.`
        return bold + remainder
      }
    },
    created () {
      this.businessAxios = axios.create({
        baseURL: process.env.API_URL
      })
      this.formsApiAxios = axios.create({
        baseURL: process.env.HUBSPOT_FORMS_API_URL
      })
      if (JSON.parse(localStorage.getItem('freeOnboard'))) {
        this.signUp.free_reference = JSON.parse(localStorage.getItem('freeOnboard')).free_reference
      }
      const tracking = this.$cookie.get('__itluid')
      if (typeof tracking !== 'undefined' && tracking !== null) {
        this.signUp.tracking_reference = tracking
      } else {
        this.signUp.tracking_reference = this._uid
      }
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Free Onboard'
      })
    },
    methods: {
      /**
       * Handle the entered email
       * @return {void}
       */
      handleEmailEntry () {
        this.$gtm.trackEvent({
          event: 'EnterWorkEmailAdd'
        })
        axios.post(`onboard/verify-email`, {
          email: this.signUp.email
        })
        .then(({data}) => {
          localStorage.setItem('freeOnboard', JSON.stringify({
            free_reference: data.free_reference
          }))
          Object.assign(this.signUp, {
            step: 2,
            free_reference: data.free_reference
          })
        })
        .catch((error) => {
          this.showFlash(error.response.data.email[0], 'is-danger')
          console.log(error.response.data.email[0])
        })
      },
      /**
       * Hide all business auto complete
       * @return {void}
       */
      hideBusinessAutoComplete () {
        this.searchResults = []
      },
      /**
       * On captcha expired
       * @return {void}
       */
      onCaptchaExpired () {
        this.$refs.recaptcha.reset()
      },
      /**
       * When selecting the business
       * @return {void}
       */
      selectBusiness (business) {
        this.searchResults = []
        this.signUp.business_id = business.id
        this.signUp.business_name = business.name
        this.signUp.businessSlug = business.slug
        this.business_is_selected = true
        this.selected_business_available = business.status !== 'ACTIVE'
      },
      /**
       * Handle searching business
       * @param {object} e
       * @return {void}
       */
      async handleSearchBusinesses (e) {
        this.searchResults = []
        this.business_is_selected = false
        this.signUp.business_id = 0
        const searchTerm = e.target.value
        if (typeof this.searchCancelToken !== 'undefined') {
          this.searchCancelToken.cancel('Operation cancelled due to new request from user search input')
        }
        if (searchTerm.length < 4) {
          this.is_fetching_business = false
          return
        }
        this.is_fetching_business = true
        this.searchCancelToken = axios.CancelToken.source()
        try {
          let keyword = encodeURIComponent(this.signUp.business_name)
          const results = await this.businessAxios.get(`/search/unclaimed-business?name=${keyword}`)
          console.log('results', results)
          this.is_fetching_business = false
          if (typeof results.data !== 'undefined' && results.data.length > 0) {
            results.data.forEach((record) => {
              record.id = record.id
              record.name = record.name
              record.slug = record.slug
              record.status = record.status
            })
            this.searchResults = results.data
          } else {
            this.searchResults = []
          }
        } catch (error) { console.log('request elastic error', error) }
      },
      /**
       * Handle add new unclaimed business
       * @return {void}
       */
      handleAddBusiness (e) {
        e.preventDefault()
        axios.post(`onboard/can-add-business`, {
          business_name: this.signUp.business_name
        })
        .then(({data}) => {
          this.business_is_selected = true
        })
        .catch((error) => {
          this.showFlash(error.response.data.errors.business_name[0], 'is-danger')
        })
      },
      /**
       * Handle create new business account
       * @param {String} recaptchaToken
       * @return {void}
       */
      handleCreateAccount (e) {
        e.preventDefault()
        axios.post(`onboard/verify-email`, {
          email: this.signUp.email
        })
          .then(({data}) => {
            localStorage.setItem('freeOnboard', JSON.stringify({
              free_reference: data.free_reference
            }))
            Object.assign(this.signUp, {
              step: 2,
              free_reference: data.free_reference
            })
            this.$refs.recaptcha.execute()
          })
          .catch((error) => {
            this.showFlash(error.response.data.email[0], 'is-danger')
            console.log(error.response.data.email[0])
          })
      },
      /**
       * Handle create new business account
       * @param {String} recaptchaToken
       * @return {void}
       */
      onCaptchaVerified (recaptchaToken) {
        this.$refs.recaptcha.reset()
        this.isAddingBiz = this.signUp.isLoading = true
        this.signUp.token = recaptchaToken
        const hutkCookie = this.$cookie.get('hubspotutk')
        this.signUp.hubspot_cookie = hutkCookie
        this.$gtm.trackEvent({
          event: 'CreateBusinessAccount'
        })
        axios.post(`onboard/create_free`, this.signUp)
        .then(({data}) => {
          this.isAddingBiz = this.signUp.isLoading = false
          // successfully posted to our API, so here we use FormsAPI for HubSpot
          // https://api.hsforms.com/submissions/v3/integration/submit/:portalId/:formGuid
          const hubspotPortalId = process.env.HUBSPOT_CODE
          const freeFormId = process.env.HUBSPOT_FORMS_FREE_ID
          const formUrl = `submissions/v3/integration/submit/${hubspotPortalId}/${freeFormId}`

          this.formsApiAxios.post(formUrl, {
            fields: [
              {
                objectTypeId: '0-1',
                name: 'email',
                value: this.signUp.email
              },
              {
                objectTypeId: '0-1',
                name: 'firstname',
                value: this.signUp.first_name
              },
              {
                objectTypeId: '0-2',
                name: 'name',
                value: this.signUp.business_name
              }
            ],
            context: {
              hutk: hutkCookie
            }
          }).then((response) => {
            console.log('forms API Response', response)
          })

          if (typeof data.token !== 'undefined' && data.token.length > 0) {
            // free auto login
            localStorage.clear()
            if (typeof window.Intercom !== 'undefined') {
              window.Intercom('shutdown')
            }
            localStorage.setItem('auth_token', data.token)
            localStorage.setItem('is_ops', JSON.parse(data.is_ops))
            localStorage.setItem('first_name', data.first_name)
            localStorage.setItem('last_name', data.last_name)
            localStorage.setItem('email', data.email)
            localStorage.setItem('mobile_number', data.mobile_number)
            localStorage.setItem('roles', JSON.stringify(data.roles))
            localStorage.setItem('is_hp_admin', JSON.parse(data.is_hp_admin))
            localStorage.setItem('can_add_more_users', JSON.parse(data.can_add_more_users))
            localStorage.setItem('org_slug', data.org_slug)
            localStorage.setItem('user_id', data.user_id)
            localStorage.setItem('is_admin_menu_active', false)
            localStorage.setItem('user_hash', data.user_hash)
            if (typeof data.first_login !== 'undefined' && data.first_login) {
              this.$gtm.trackEvent({
                event: 'FirstTimeLogin'
              })
            }
            this.setDefaultBusiness(data.roles)
            const email = localStorage.getItem('email')
            const firstName = localStorage.getItem('first_name')
            const lastName = localStorage.getItem('last_name')
            const fullName = `${firstName} ${lastName}`.trim()
            const createdAt = localStorage.getItem('org_join_date')
            const userHash = localStorage.getItem('user_hash')
            window.Intercom('boot', {
              app_id: process.env.INTERCOM_ID,
              name: `${fullName}`,
              email: `${email}`,
              user_hash: userHash,
              created_at: createdAt
            })
            axios.get(`/${data.org_slug}/billing-details`)
              .then((response_data) => {
                localStorage.setItem('billingDetails', JSON.stringify(response_data.data))

                // push GTM event
                this.$gtm.trackEvent({
                  event: 'conversionSuccess',
                  type: 'Login'
                })

                let url
                if (this.$route.query.redirect) {
                  url = this.$route.query.redirect
                } else if (localStorage.is_admin_menu_active === 'true' && localStorage.is_hp_admin === 'true') {
                  url = '/reviews-listing'
                } else {
                  url = '/'
                }
                this.$router.replace(url)
              })
              .catch((error) => {
                console.log('get billing details error', error)
              })
            // end free auto login
          } else {
            this.$gtm.trackEvent({
              event: 'BusinessProfileUnderReview'
            })
            Object.assign(this.signUp, {
              step: 3,
              business_id: data.business_id
            })
            window.scrollTo(0, 0)
          }
          // ====-
        })
        .catch((error) => {
          this.isAddingBiz = this.signUp.isLoading = false
          Object.keys(error.response.data.errors).forEach((key) => {
            if (error.response.data.errors[key]) {
              this.showFlash(error.response.data.errors[key][0], 'is-danger')
            } else {
              this.showFlash(error.response.data, 'is-danger')
            }
          })
          console.log(error.response.data)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  $text-color: #58595b;
  $link-color: #30aae1;
  $blue-text-color: #1261a0;

  .onboard-container {
    max-height: 700px;

    .columns:not(:last-child) {
      margin-bottom: 0;
    }
    .equal-height {
      display:flex;
      flex-direction:column;
      justify-content:space-between
    }
    .create-your-account {
      color: $blue-text-color;
      margin-top: 40px;
      font-size: 28px;
      font-weight: bold;
      line-height: 0.86;
      text-align: center;

      &.second-step {
        font-size: 24px;
      }

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    .form-box {
      width: 100%;
      margin: 0 auto;
      max-width: 697px;

      .form-para {
        color: $text-color;
        padding: 10px;
        font-size: 16px;
      }
    }
    .email-section {
      padding: 30px 100px;

      input {
        height: 40px;
      }
      .button {
        height: 40px;

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          width: 100%;
          margin-top: 12px;
        }
      }
      .label {
        color: $text-color;
        font-size: 14px;
      }

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        padding: 0;
      }
    }
    .dropdown-section {
      .control {
        position: absolute;

        .dropdown {
          width: 100%;
        }
        .dropdown-menu {
          width: 100%;
        }
        &.business-name {
          width: calc(100% - 60px);
        }
      }
      .selected-business {
        top: 18%;
        left: 3%;
        color: transparent;
        z-index: 1;
        opacity: 0.32;
        padding: 3px 8px;
        position: absolute;
        font-size: 14px;
        font-weight: 600;
        // background-color: #1f91c3;
      }
    }
    .biz-form {
      width: 80%;
      padding: 0 100px;

      .first-name-label {
        margin: 40px 0 0 0;

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          margin-left: 9%;
        }
      }
      .mini-notes {
        color: $text-color;
        padding: 5px 14px;
        font-size: 12px;
      }
      .dropdown-content {
        .dropdown-item {
          color: $text-color;
          font-size: 12px;
        }
      }
      .create-account {
        width: 341px;
        color: #ffffff;
        border: none;
        margin-top: 40px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.36;
        text-align: center;
        letter-spacing: normal;
        font-family: Open Sans;
        background-color: $blue-text-color;

        &:disabled {
          background-color: #dbdbdb;
        }

        /*Mobile view*/
        @media screen and (max-width: 767px) {
          width: 100%;
        }
      }
      .labels {
        color: $text-color;
        font-size: 14px;
      }
      .dropdown-menu {
        border-top: 5px solid $blue-text-color;
      }
      .no-business {
        color: #58595b;
        font-size: 12px;

        &-section {
          padding: 12px 0px;
          margin: 0px 12px;
          border-bottom: solid 1px rgba(88, 89, 91, 0.4);
        }
        .is-button-dark-blue {
          width: 65%;
        }
      }
      .agree-label {
        font-family: Open Sans;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: $text-color;

        a, a:visited {
          text-decoration: none;
          color: $text-color;
        }

        a:hover {
          text-decoration: underline;
          color: $text-color;
        }

        .checkbox {
          width: 17px;
          height: 17px;
          -webkit-appearance: none;
          border-radius: 0;
          border: solid 1px #ebebeb;
        }
      }

      input[type=checkbox]:before {
        /* Show some fake element to keep the space for empty "square" */
        content: '\f0c8';
        color: transparent;
      }
      input[type=checkbox]:checked:before {
        content: '\2713 ';
        padding-left: 2px;
        font-size: 15px;
        line-height: 0.8;
        color: $text-color;
        font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
      }
      .policy-section {
        position: absolute;
        margin-left: -55px;
      }

      /*Mobile view*/
      @media screen and (max-width: 767px) {
        width: 100%;
        padding: 0;

        .policy-section {
          margin-left: -28px;

          .agree-label {
            width: 100%;
            font-size: 11px;
          }
        }
      }
    }
    p.ask-sign-in {
      margin-top: 30px;
      font-size: 14px;
      line-height: 1.71;
      text-align: center;
      color: $text-color;

      a {
        color: #2fabe1;
        font-weight: normal;
        text-decoration: underline;
      }
    }
    .summary-column {
      min-height: 610px;
      margin-top: 1% !important;
      padding-bottom: 35px;
      padding-top: 0;
      border-left: solid 1px rgba(112, 112, 112, 0.12);
    }
    .input {
      height: 40px;
      border: solid 1px #dbdbdb;
      font-size: 14px;
      line-height: 1.36;
      text-align: left;
      padding-left:18px;
    }
    .place-in-center-mobile {
      /*Mobile view*/
      @media screen and (max-width: 767px) {
        margin-left: 9%;
      }
    }

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      height: auto;

      &>>>.summary-column {
        min-height: unset;
        margin-top: unset !important;
      }
    }
  }

  /* Media queries Begins */
  @media screen and (min-width: 768px) {
    .input, .VuePassword {
      width: 341px;
    }
    .column.is-two-thirds {
      -webkit-box-flex: 0;
      -ms-flex: none;
      flex: none;
      width: 73%;
    }
    .column.is-two-thirds + .column {
      padding-top: 12px;
      padding-left: 50px;
      padding-right: 37px;
    }
    .VuePassword {
      height: 40px;
    }
    .VuePassword > div > input {
      height: 40px!important;
    }
    .create-account {
      width: 355px;
      height: 40px;
    }
    .thank-you-header {
      width: 590px;
      max-width: 610px;
      height: 136px;
      font-size: 56px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: center;
      color: #1261a0;
      margin: 20px auto 0 auto;
    }
    .thank-you-hero {
      padding: 0 0 240px 0;
    }
    .thank-you-msg {
      max-width: 755px;
      height: 72px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      margin: 0 auto;
      color: #58595b;
    }
  }
  /* Media queries Ends */

  /* Helper css begins */
  .button {
    width: 130px;
    height: 35px;
    text-transform: uppercase;

    &.button-dark-blue {
      color: #fff;
      background-color: $blue-text-color;
    }
  }
  .padding {
    &-0 {
      padding: 0;
    }
    &-top {
      &-0 {
        padding-top: 0;
      }
    }
    &-bottom {
      &-0 {
        padding-bottom: 0;
      }
    }
  }
  /* Helper css ends */
</style>

<!-- Global CSS Begins -->
<style lang="scss">
  $success: #16be85;
  $danger: #fb492c;
  $info: #31AAE1;
  $warning: #fb922c;
  $bg-color: #fff;

  .toast-container {
    min-width: 25%;
    max-width: 50%;

    &.top-right {
      right: 1%;
    }
    .toasted.outline {
      color: $bg-color;
      opacity: 0.8 !important;
      padding: 10px 15px;
      font-weight: 600;
      justify-content: end;
      border-radius: 5px;
      background-color: $bg-color;

      &.is-success {
        border: none;
        background-color: $success;
      }
      &.is-danger {
        border: none;
        background-color: $danger;
      }
      &.is-info {
        border: none;
        background-color: $info;
      }
      &.is-warning {
        border: none;
        background-color: $warning;
      }
    }
    .toasted .fa, .toasted .fab, .toasted .far,
    .toasted .fas, .toasted .material-icons, .toasted .mdi {
      font-size: 30px;
    }

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      left: 1%;
      max-width: 100%;
    }
  }
  /* Media queries Begins */
  @media screen and (max-width: 767px) {
    .footer-section {
      position: absolute;
    }
  }
</style>
<!-- Global CSS Ends -->



// WEBPACK FOOTER //
// src/pages/onboarding/FreeOnboard.vue